import React from 'react';

const DetailInfoElement = ({ title, content }: any) => {
  return (
    <div className="flex flex-col pb-6 px-3">
      <div className="flex-1 text-xs text-onSurfaceVariant">
        {title}
      </div>
      <div className="smallTitle2 pt-1 text-left">
        {content ?? <span>-----</span>}
      </div>
    </div>
  );
};

export default DetailInfoElement